import { mounthInterface } from '../components/forms/TauxDechange/InterfaceTaux';

export const XS_BREAKPOINT = 600;
export const MAX_MOBILE_WIDTH = 900;

export const PROFIL_SUPER_ADMIN = "SUPER_ADMIN";
export const PROFIL_ADV = "ADV";
export const PROFIL_FINANCE = "FINANCE";
export const PROFIL_MANAGER = "MANAGER";
export const PROFIL_GTO = "GTO";
export const PROFIL_COUNTRY_MANAGER = "COUNTRY_MANAGER";
export const PROFIL_ROA = "ROA";
export const PROFIL_SUPER_MANAGER = "SUPER_MANAGER";
export const PROFIL_DIRECTION = "DIRECTION";
export const PROFIL_DRC = "DRC";
export const PROFIL_GESTIONNER_HEURE_PROD = "GESTIONNER_HEURE_PROD";
export const PROFIL_COMMERCIAUX = "COMMERCIAUX";
export const PROFIL_PROFIL_GRC = "GRC";
export const PROFIL_DAF = "DAF";


export const profilToAccessToAllFonctionnality: string[] = [
    PROFIL_SUPER_ADMIN
];

export const profilAllAccessBudgetSiVerouiller: string[] = [
    PROFIL_SUPER_ADMIN,
    PROFIL_DAF,
    PROFIL_ADV
];

export const profilToAccessFromSaisieManager: string[] = [
    PROFIL_SUPER_ADMIN,
    PROFIL_FINANCE,
    PROFIL_ADV,
    PROFIL_GTO,
    PROFIL_DIRECTION,
    PROFIL_DRC,
    PROFIL_GESTIONNER_HEURE_PROD,
    PROFIL_MANAGER,
    PROFIL_SUPER_MANAGER
];

export const profilToAccessCommissionCommercialGRC: string[] = [
    PROFIL_COMMERCIAUX,
    PROFIL_PROFIL_GRC,
    PROFIL_DRC
];

export const idTypeInBDD: number = 2;

export const idProfilToAccessCommissionCommercialGRC: number[] = [
    10, 8
]

export const pathToHideNavbar = [
    '/sign-in'
];

export const publicPaths = [
    '/outsourcia-signature'
];

export const managerIdConstante: string = "2";

export const managerIdConstanteNumber: number = 2;

export const euroIdDevise: number = 1;

export const deviseIds_fixed3 = [2];

// Articles créés automatiquement avec l'opération : actes toujours à 0 en saisie manager
export const articlesSansActes: string[] = [
    "Heures de management non facturées – CDP",
    "Heures de management non facturées – ME",
    "Heures de management non facturées – Q&F",
];

export const codeArticleNotToDisable: string[] = [
    // 'REDA'
];

export const AllMounth: mounthInterface[] = [
    {
        id: 1,
        mounth: "Janvier"
    }, {
        id: 2,
        mounth: "Février"
    }, {
        id: 3,
        mounth: "Mars"
    }, {
        id: 4,
        mounth: "Avril"
    }, {
        id: 5,
        mounth: "Mai"
    }, {
        id: 6,
        mounth: "Juin"
    }, {
        id: 7,
        mounth: "Juillet"
    }, {
        id: 8,
        mounth: "Août"
    }, {
        id: 9,
        mounth: "Septembre"
    }, {
        id: 10,
        mounth: "Octobre"
    }, {
        id: 11,
        mounth: "Novembre"
    }, {
        id: 12,
        mounth: "Décembre"
    },
];

export const yearsToDisplay = [
    new Date().getFullYear(),
    new Date().getFullYear() + 1
];

export const PORTFOLIO_TYPE = 2;

export const MODE_PROD = "prod";
export const MODE_BUDGET = "budget";

export const profilsCanManagePotentielClientOperation = [
    PROFIL_DRC,
    PROFIL_ADV,
    PROFIL_COMMERCIAUX,
    PROFIL_SUPER_ADMIN
  ];